import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import LandingWrapper from "../../../components/landing/landing";
import { routeUrls, routeVariables } from "../../../navigation/routeUrls";

import { useAuthenticateToFleetTrack2Mutation } from "../../../api/network/authApiService";
import svgIcons from "../../../assets/svg/svgIcons";
import { useLoginHandler } from "../../../hooks/loginHandler";
import './authenticate.scss';

interface ScreenAuthenticateProps {
  // showSessionExpiredMessage?: boolean;
}

const ScreenAuthenticate: FC<ScreenAuthenticateProps> = ({
  // showSessionExpiredMessage
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'authenticateScreen' });
  const { t: tMain } = useTranslation();
  const routeParams = useParams();
  const authCode = routeParams?.[routeVariables.authCode];

  // handler for all success and error scenarios after login
  const loginHandler = useLoginHandler({ screen: 'authenticateScreen' });

  const [authenticateApiTrigger, {
    isLoading: isAuthenticating,
    error: authenticateError
  }] = useAuthenticateToFleetTrack2Mutation()

  useEffect(() => {
    if (authCode) {
      authenticateApiTrigger({ code: authCode })
        .unwrap()
        .then(loginHandler.loginSuccessHandler)
        .catch(loginHandler.loginErrorHandler);
    }
  }, []);

  return (
    <LandingWrapper>
      <div className="p-8 bg-white grid grid-cols-6 gap-6 rounded-3xl shadow-2xl">

        <h2 className="col-span-6 text-3xl font-bold text-heading-black">{t("heading")}</h2>

        {isAuthenticating ? (
          <>
            <p className="col-span-6 text-base text-gray-500">{t("sub_heading")}</p>
            <img
              src={svgIcons.LoadingAnimation}
              alt="loading"
            />
          </>
        ) : (
          <>
            {authenticateError && (
              <p className="col-span-6">{t('toast.authentication_failed')}</p>
            )}
            <Link
              to={routeUrls.landingPage}
              className={`col-span-6 flex items-center justify-center mt-4 h-12 w-full rounded-full border text-sm font-display font-semibold transition focus:outline-none focus:ring border-accent-blue-pale bg-accent-blue-pale text-accent-blue-dark enabled:hover:bg-accent-blue-dark enabled:hover:text-white active:bg-accent-blue-pale`}>
              {t('back_to_home')}
            </Link>
          </>
        )}

      </div>
    </LandingWrapper>
  );
}
export default ScreenAuthenticate;